<!--  -->
<template>
  <div class="container acvitity_foot_left_group">
    <common-title
      titleName="学习报告"
      :bcColor="'#F9F9F9'"
      :isAPPShow="true"
      :zIndex="1000"
      v-if="!isMiniProgram"
    ></common-title>
    <template v-if="!isEmpty">
      <section :class="isMiniProgram ? 'section miniprogram' : 'section'">
        <div class="report_bkg">
          <div class="bkg_name">{{ productName }}</div>
          <div class="bkg_title_box">
            <img
              class="title_img"
              :src="userInfo.avatar || require('../../../assets/img/personalImg/defaultAvatar.png')"
              alt
            />
            <div class="title_name">Hi, {{ userInfo.nickName || userInfo.userName }}</div>
            <div class="title_num">
              你已经累计学习
              <div>{{studyInfo.learnDays}}</div>天了，真棒！
            </div>
          </div>
        </div>

        <div class="under_box">
          <!-- 课程学习进度 -->
          <div class="course_box">
            <div class="course_progress_box">
              <div class="progress_icon"></div>
              <div class="progress_text">课程学习进度</div>
              <img
                @click="instrucTionsOpen"
                class="progress_btn"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/progress_icon.png"
                alt
              />
            </div>

            <div class="learn_progress_box">
              <div class="learn_progress">
                <div id="reportEChart1" style="width: 100%; height: 100%"></div>
                <div class="progress_tip">学习进度</div>
                <div class="percent">{{ toolFixed((studyInfo.productLearnProgress || 0) * 100 )}}%</div>
              </div>
              <div
                :class="['learn_progress', studyInfo.total !== 0 ? '' : 'learn_progress_box_none']"
              >
                <div id="reportEChart2" style="width: 100%; height: 100%"></div>
                <div class="progress_tip">每日任务完成度</div>
                <div class="percent">{{ dayTaskPrecent }}%</div>
              </div>
            </div>

            <!-- 累计学习时长 -->
            <div class="learn_time_box">
              <img
                class="time_icon1"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/learn_time_color.png"
                alt
              />
              <img
                class="time_icon2"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/learn_time_icon.png"
                alt
              />
              <div class="time_name">累计学习时长</div>
              <div class="time_long_num">{{ studyInfo.learnDuration }}</div>
              <div class="time_long_text">分钟</div>
            </div>

            <!-- 班级排名 -->
            <div class="learn_time_box learn_time_box2" v-if="studyInfo.classRanking != -1">
              <img
                class="time_icon1"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/class_sort_color.png"
                alt
              />
              <img
                class="time_icon2"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/class_sort_icon.png"
                alt
              />
              <div class="time_name">班级排名</div>
              <div class="time_long_num">{{ studyInfo.classRanking }}</div>
              <div class="time_long_text">名</div>
            </div>

            <!-- 五个数据 -->
            <div class="data_box">
              <div class="data_item">
                <div class="data_title">完成直播课</div>
                <div class="data_num">{{ studyInfo.finishLiveNumber }}/{{studyInfo.liveNumber}}节</div>
              </div>

              <div class="data_item">
                <div class="data_title">完成录播课</div>
                <div class="data_num">{{ studyInfo.finishVideoNumber }}/{{studyInfo.videoNumber}}节</div>
              </div>
            </div>

            <div class="data_box data_box_three">
              <div class="data_item data_item_three" v-if="studyInfo.questionAnswerTimes !== -1">
                <div class="data_title">平台答疑</div>
                <div class="data_num">{{ studyInfo.questionAnswerTimes }}</div>
              </div>

              <div class="data_item data_item_three" v-if="studyInfo.correctNum !== -1">
                <div class="data_title">批改</div>
                <div class="data_num">{{ studyInfo.correctNum }}</div>
              </div>

              <div class="data_item data_item_three" v-if="studyInfo.examNum !== -1">
                <div class="data_title">考试</div>
                <div class="data_num">{{ studyInfo.examNum }}/{{studyInfo.examTotalNum}}场</div>
              </div>
            </div>

            <!-- ai区域 -->
            <div class="ai_box" v-if="aiStatus != -1">
              <div class="ai_title_box">
                <div class="ai_title_fail" v-if="aiStatus == 3">
                  分析失败，
                  <div class="ai_title_fail_btn" @click="getAiContent(1)">重新分析</div>
                </div>
                <div class="ai_title_loading" v-if="aiStatus == 1">
                  <div>正在分析</div>
                  <img
                    class="ai_title_loading_icon"
                    src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/ai_loading_icon.gif"
                    alt
                  />
                </div>
              </div>
              <div class="ai_content_box" v-if="aiStatus == 2">{{ aiContent }}</div>
              <div class="ai_content_box_fail" v-if="aiStatus == 3">
                <img
                  class="ai_content_fail_img"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/ai_empty_icon.png"
                  alt
                />
                <div class="ai_content_fail_text">分析失败</div>
              </div>
              <div class="ai_tip" v-if="aiStatus == 2">*内容由AI生成</div>
            </div>
          </div>

          <!-- 听课时长  本期先隐藏掉 v-if="false" -->
          <div class="learn_box">
            <div class="course_progress_box">
              <div class="progress_icon"></div>
              <div class="progress_text">听课时长</div>
            </div>
            <div class="learn_info_box">
              本周已学习
              <div class="learn_info_box_num">{{ dayInfo.learnDuration }}</div>分钟
              <div class="learn_info_box_text" v-if="dayInfo.showUp || dayInfo.showDown">，相比上周同期</div>
              <img
                class="learn_info_box_img"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/course_time_up.png"
                alt
                v-if="dayInfo.showUp"
              />
              <img
                class="learn_info_box_img"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/course_time_down.png"
                alt
                v-if="dayInfo.showDown"
              />
              <div class="learn_info_box_text" v-if="dayInfo.showUp || dayInfo.showDown">
                {{ dayInfo.ratio }}%,{{
                dayInfo.showUp ? '给自己点赞' : '' }}{{ dayInfo.showDown ? '继续努力' : '' }}
              </div>
            </div>
            <div class="learn_btn_box" v-if="false">
              <div
                :class="['learn_btn', activeCountType === 1 ? 'learn_btn_active' : '']"
                @click="onChangeCountType(1)"
              >日统计</div>
              <div
                :class="['learn_btn', activeCountType === 2 ? 'learn_btn_active' : '']"
                @click="onChangeCountType(2)"
              >周统计</div>
            </div>
            <div class="learn_charts_box">
              <div class="learn_enpty" :style="{ 'z-index': 10 }" v-if="!weekTimeShow">
                <img
                  class="learn_enpty_img"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/learn_empty.png"
                  alt
                />
                <div class="learn_enpty_text">近{{ activeCountType === 1 ? '七天' : '几周' }}还没有听课，快去听课吧!</div>
              </div>

              <div class="learn_charts_title">
                <div class="charts_mins"></div>
                <div class="charts_info_box">
                  <div class="charts_info_tip">{{ lastStudyInfo.dayLearnDuration }}分钟</div>
                  <div class="charts_info_time">
                    {{ lastStudyInfo.statisticsDate }} | {{ activeCountType === 1 ? '昨天' :
                    '本周' }}
                  </div>
                </div>
              </div>

              <div class="learn_charts_line"></div>

              <div class="learn_charts_colmnus">
                <div id="columnchart" style="width: 100%; height: 100%"></div>
              </div>

              <div class="learn_charts_average" v-if="weekTimeShow && activeCountType === 1">
                <div class="charts_average_num">{{ weekAverage }}</div>
                <div class="charts_average_tip">分钟 | 近7天平均</div>
              </div>
            </div>
          </div>

          <!-- 考试数据 -->
          <div class="test_box" v-if="studyExamList && studyExamList.length != 0">
            <div class="course_progress_box">
              <div class="progress_icon"></div>
              <div class="progress_text">考试</div>
            </div>

            <div class="test_title_box">
              共参加了
              <div class="test_title_num">{{ studyInfo.examNum >= 0 ? studyInfo.examNum : 0 }}</div>场考试，考试平均分
              <div class="test_title_num">{{ studyInfo.averageScore || 0 }}</div>分
            </div>

            <div class="test_list_title">
              <div class="title_name">考试名称</div>
              <div class="title_num">成绩</div>
              <div class="title_sort">排名</div>
            </div>

            <div class="test_list_box">
              <div class="test_list_item" v-for="item in studyExamList" @click="onGoExam(item)">
                <div class="test_item_name">{{ item.examName }}</div>
                <div class="test_item_num">{{ item.score || 0 }}</div>
                <div class="test_item_sort">{{ item.rank + 1 === 0 ? '-' : item.rank }}</div>
                <img
                  class="test_btn_icon"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/test_btn_icon.png"
                  alt
                />
              </div>
            </div>

            <div class="test_expand" v-if="expandStatus">
              <div @click="onExpandChange">展开</div>
              <img
                @click="onExpandChange"
                class="test_expand_icon_rotate"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/test_expand_icon.png"
                alt
              />
            </div>
          </div>

          <!-- 知识点分析 -->
          <div
            class="knowledge_box"
            v-if="knowledgeStatus !== 0 && ( knowledgeStatus !== 2 || knowledgeList.length != 0 )"
          >
            <div class="course_progress_box">
              <div class="progress_icon"></div>
              <div class="progress_text">知识点分析</div>
            </div>

            <div class="knowledge_title_box">以下为掌握率较低的知识点，要加强练习！</div>

            <div class="knowledge_list_title" v-if="knowledgeList.length != 0">
              <div>知识点</div>
              <div>掌握程度</div>
            </div>

            <div class="knowledge_list_box" v-if="knowledgeList.length != 0">
              <div class="knowledge_item" v-for="item in knowledgeList" :key="item.knowledgeId">
                <div class="knowledge_item_name">{{ item.knowledgeName }}</div>
                <div class="knowledge_item_precent">{{ item.correctRatio }}%</div>
              </div>
            </div>
            <img
              v-if="knowledgeStatus == 1 || knowledgeStatus == 3"
              class="knowledge_list_empty_img"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/know_empty.png"
              alt
            />
            <div
              v-if="knowledgeStatus == 1 || knowledgeStatus == 3"
              class="knowledge_list_empty_text"
            >知识点生成中</div>

            <div
              v-if="knowledgeStatus == 1 || knowledgeStatus == 3"
              class="knowledge_list_empty_block"
            ></div>

            <div class="knowledge_course_icon">
              <img
                class="knowledge_one_img"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/knowledge_one_icon.png"
                alt
              />
              <div class="knowledge_one_tip" v-if="recommendMore" @click="lookMoreList">更多</div>
              <img
                class="knowledge_one_more"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/knowledge_more_icon.png"
                alt
              />
            </div>

            <div class="knowledge_course_box">
              <img class="knowledge_course_img" :src="prodInfo.coverMobile" alt />
              <div class="knowledge_course_name">{{ prodInfo.name }}</div>
              <div class="knowledge_course_num">
                {{ Number(prodInfo.realSales || 0) + Number(prodInfo.initialSales || 0)
                }}人已购买
              </div>
              <div class="knowledge_course_price">
                <!-- 划线价 -->
                <del
                  v-if="(prodInfo.productDiscountRespVO && prodInfo.productDiscountRespVO.isGroupDiscount) || prodInfo.promotionLabel"
                  class="course_line_price"
                >￥{{ prodInfo.originalPrice }}</del>

                <div class="course_price_box">
                  <!-- 拼团价 -->
                  <div
                    class="course_price_tip"
                    v-if="prodInfo.productDiscountRespVO && prodInfo.productDiscountRespVO.isGroupDiscount"
                  >拼团价</div>

                  <!-- 促销价 -->
                  <div class="course_price_tip" v-else-if="prodInfo.promotionLabel">
                    {{ prodInfo.promotionLabel === 1 ?
                    '折后价' :
                    prodInfo.promotionLabel === 4 ? '券后价' : '限时价' }}
                  </div>

                  <!-- 价格icon -->
                  <div
                    class="course_price_icon"
                    v-if="(prodInfo.productDiscountRespVO && prodInfo.productDiscountRespVO.isGroupDiscount) || !(prodInfo.sellPrice === 0 && !prodInfo.promotionLabel)"
                  >￥</div>

                  <!-- 价格 -->
                  <div
                    class="course_price_num"
                    v-if="prodInfo.productDiscountRespVO && prodInfo.productDiscountRespVO.isGroupDiscount"
                  >{{ prodInfo.productDiscountRespVO.discountMinPrice }}</div>

                  <!-- 免费 -->
                  <div class="course_price_free" v-else>
                    {{
                    prodInfo.sellPrice === 0 && !prodInfo.promotionLabel ? '' : prodInfo.sellPrice
                    }}
                  </div>
                </div>
              </div>
              <div class="knowledge_course_btn" @click="openPopup(prodInfo)">
                {{ prodInfo.sellPrice === 0 && !prodInfo.promotionLabel ? '立即咨询' :
                '立即咨询' }}
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="share-btn-Box">
        <button class="share-btn" @click="toShare">分享</button>
      </div>
      <van-popup class="popup" v-model="showShare" :round="true" @click-overlay="showShare = false">
        <div class="share_box" v-if="!shareImgUrl" ref="imageWrapper">
          <img
            class="share_bkg"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/share_bkg_icon.png"
            alt
            crossorigin="Anonymous"
          />
          <div class="share_title">{{ productName }}</div>
          <div class="share_days">
            你已经累计学习
            <div>{{studyInfo.learnDays}}</div>天了，真棒！
          </div>
          <div class="course_box">
            <div class="course_progress_box">
              <div class="progress_icon"></div>
              <div class="progress_text">课程学习进度</div>
              <!-- <img
                @click="instrucTionsOpen"
                class="progress_btn"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/progress_icon.png"
                alt
                crossorigin="Anonymous"
              />-->
            </div>

            <div class="learn_progress_box">
              <div class="learn_progress">
                <div id="reportEChart1_modal" style="width: 100%; height: 100%"></div>
                <div class="progress_tip">学习进度</div>
                <div class="percent">{{ toolFixed((studyInfo.productLearnProgress || 0) * 100 )}}%</div>
              </div>
              <div
                v-if="studyInfo.total && studyInfo.total !== 0"
                :class="['learn_progress', studyInfo.total !== 0 ? '' : 'learn_progress_box_none']"
              >
                <div id="reportEChart2_modal" style="width: 100%; height: 100%"></div>
                <div class="progress_tip">每日任务完成度</div>
                <div class="percent">{{ dayTaskPrecent }}%</div>
              </div>
            </div>

            <!-- 累计学习时长 -->
            <div class="learn_time_box">
              <img
                class="time_icon1"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/learn_time_color1.png"
                alt
                crossorigin="Anonymous"
              />
              <img
                class="time_icon2"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/learn_time_icon1.png"
                alt
                crossorigin="Anonymous"
              />
              <div class="time_name">累计学习时长</div>
              <div class="time_long_num">{{ studyInfo.learnDuration }}</div>
              <div class="time_long_text">分钟</div>
            </div>

            <!-- 班级排名 -->
            <div class="learn_time_box learn_time_box2" v-if="studyInfo.classRanking != -1">
              <img
                class="time_icon1"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/class_sort_color1.png"
                alt
                crossorigin="Anonymous"
              />
              <img
                class="time_icon2"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/class_sort_icon1.png"
                alt
                crossorigin="Anonymous"
              />
              <div class="time_name">班级排名</div>
              <div class="time_long_num">{{ studyInfo.classRanking }}</div>
              <div class="time_long_text">名</div>
            </div>

            <!-- 五个数据 -->
            <div class="data_box">
              <div class="data_item">
                <div class="data_title">完成直播课</div>
                <div class="data_num">{{ studyInfo.finishLiveNumber }}/{{studyInfo.liveNumber}}节</div>
              </div>

              <div class="data_item">
                <div class="data_title">完成录播课</div>
                <div class="data_num">{{ studyInfo.finishVideoNumber }}/{{studyInfo.videoNumber}}节</div>
              </div>
            </div>

            <div class="data_box data_box_three">
              <div class="data_item data_item_three" v-if="studyInfo.questionAnswerTimes !== -1">
                <div class="data_title">平台答疑</div>
                <div class="data_num">{{ studyInfo.questionAnswerTimes }}</div>
              </div>

              <div class="data_item data_item_three" v-if="studyInfo.correctNum !== -1">
                <div class="data_title">批改</div>
                <div class="data_num">{{ studyInfo.correctNum }}</div>
              </div>

              <div class="data_item data_item_three" v-if="studyInfo.examNum !== -1">
                <div class="data_title">考试</div>
                <div class="data_num">{{ studyInfo.examNum }}/{{studyInfo.examTotalNum}}场</div>
              </div>
            </div>
          </div>

          <div class="share_code_box">
            <img
              class="share_qh_img"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/share_qh_icon.png"
              alt
              crossorigin="Anonymous"
              @load="imgLoadNum +=1"
            />
            <img
              class="share_load_code"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/appdown.png"
              alt
              crossorigin="Anonymous"
              @load="imgLoadNum +=1"
            />
          </div>
        </div>
        <img class="share_img_box" crossorigin="Anonymous" v-else :src="shareImgUrl" alt />
      </van-popup>

      <InstructionsPop
        v-if="popShow"
        :contentInstructions="contentInstructions"
        @popClose="popClose"
      />

      <!-- <ShareReport v-if="showShare" :studyInfo="studyInfo" :showWeekInfo="showWeekInfo" /> -->
    </template>
    <!-- <EmptyData v-else :emptyName="'noReport'" /> -->
    <!-- <CommonLoading v-if="loading" /> -->

    <van-popup v-model="showPop" position="bottom" :get-container="getContainer">
      <div class="close-btn" @click="showPop = false">
        <van-icon name="cross" />
      </div>
      <component
        v-if="showPop"
        :is="communityType | typeToComponentName"
        :communityInfo="communityInfo"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  reqStudyReport,
  reqStudyBasisInfo,
  reqStudyExamInfo,
  reqStudyServiceInfo,
  reqStudyDayTime,
  reqStudyWeekTime,
  reqStudyDayTaskInfo,
  reqAiContent,
  reqKnowPre,
  reqKnowContent,
} from '@/api/learningGuidePage';
// import EmptyData from '@/components/emptyData/emptyData.vue';
import { replaceHyphens, whatEev } from '@/utils/tools';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import ShareReport from './shareReport.vue';
import StudyProgress from './studyProgress.vue';
import StudyColumn from './studyColumn.vue';
import StudyExam from './studyExam.vue';
import { Column } from '@antv/g2plot';
import html2canvas from 'html2canvas';
import InstructionsPop from './instructionsPop.vue';
import { reqMajorAd, reqProducts } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import { reqCourseCommunitySku } from '@/api/courseDetail/community/community';

import qqPopupComponent from '@/components/courseDetail/footCommuntiy/qqPopupComponent.vue';
import wxPopupComponent from '@/components/courseDetail/footCommuntiy/wxPopupComponent.vue';
import { reqCourseDetailStreamline } from '@/api/courseDetail/index';
import { reqCheckUserCourse } from '@/api/learn/index'

import wx from 'weixin-js-sdk';

export default {
  components: {
    ShareReport,
    StudyProgress,
    // EmptyData,
    StudyColumn,
    StudyExam,
    CommonLoading,
    InstructionsPop,
    qqPopupComponent,
    wxPopupComponent,
  },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === '1-1' || val === '1-2') {
        componentName = 'qqPopupComponent';
      } else if (val === '2-1' || val === '2-2' || val === 'wxAccount') {
        componentName = 'wxPopupComponent';
      }
      return componentName || '';
    },
  },
  data() {
    return {
      showPop: false,
      communityType: '', // 社群按钮类型
      communityInfo: {}, // 社群详情信息

      productName: '',
      showShare: false,
      activeCountType: 1,
      pageNum: 1,
      studyInfo: {},
      dayTaskPrecent: 0,
      showWeekInfo: true,
      isEmpty: false,
      studyExamList: [],
      weekTimeList: [],
      weekTimeShow: true,
      showExam: false,
      examPages: 0,
      loading: true,
      isMiniProgram: false,
      myChart1: null,
      myChart2: null,

      myChart1_modal: null,
      myChart2_modal: null,

      aiLoading: false,

      expandStatus: true,
      nextExamLoading: false,

      imgLoadNum: 0,

      popShow: false,
      contentInstructions: [
        '1.课程学习进度=所有已更新视频观看进度的平均值（随课程陆续更新，学习进度可能会减少）。',
        '2.累计学习：课程累计观看时长之和。',
        '3.班级排名：所在班级同科目课程的学习进度排名。',
        '4.课程完成规则：直播课/直播回放或录播课观看时长至少占每节课总时长80%。 离线播放会在下一次联网时自动同步进度。',
        '5.答疑、考试、批改均为APP平台提交的次数。',
        '6.学习时长：直播、回放、录播的观看时长；重复观看会重复计算时长。',
      ],

      shareImgUrl: '',

      dayInfo: {},

      aiStatus: 1,
      aiContent: '',

      lastStudyInfo: {},
      weekAverage: 0,

      knowledgeList: [],
      knowledgeStatus: 0,

      prodInfo: {},

      recommendMore: false,

      hotSaleId: 572,

      productId: '',
      skuId: ''
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    showShare(val) {
      if (!val) {
        setTimeout(() => {
          this.shareImgUrl = '';
        }, 0);
      }
    },
  },
  methods: {
    openPopup(val) {
      reqCourseDetailStreamline(val.productId).then(res => {
        console.log(res, 'detail');
        gio('track', 'CourseConsultation_ever', {
          courseld_var: val.productId,
          courseName_var: val.name,
          courseCate_var: res.data.productCategoryName,
          courseSubject_var: val.productCategoryName,
          enter_var: this.productName,
        });
      });
      console.log(val, 'val');
      const { productId, productSkuSimpleVOS } = val;
      // const { productSkuId } = productSkuSimpleVOS?.[0] || {};
      reqCourseCommunitySku(this.productId, this.skuId).then(request => {
        if (request.data && request.data?.productId) {
          this.communityInfo = request.data;
          if (request.code === 0 && request.data) {
            const { data } = request;
            this.communityType = `${data.platform}-${data.accountType}`;
          } else {
            this.communityType = 'wxAccount';
          }
          this.showPop = true;
        } else {
          sessionStorage.setItem('back', true);
          this.$router.push({
            path: '/courseDetail?playIcon=true',
            query: {
              courseId: productId,
            },
          });
        }
      });
    },
    getContainer() {
      return document.querySelector('.acvitity_foot_left_group');
    },
    instrucTionsOpen() {
      this.popShow = true;
    },
    popClose() {
      this.popShow = false;
    },

    toImage() {
      html2canvas(this.$refs.imageWrapper, {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题
        scale: 2,
        allowTaint: true,
      }).then(canvas => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.shareImgUrl = dataURL;
        // app内分享
        if (this.$root.isApp) {
          this.$sendToApp(
            'shareStudyReport',
            {
              url: this.shareImgUrl,
              title: '学习报告',
              content: '',
              icon: '',
            },
            false,
          );
        }
      });
    },

    onGoExam(item) {
      console.log(item, '去考试报告页');
      const { examId } = item;
      if (this.$root.$data.isApp) {
        const url = `${window.location.origin}/mockExam/answerReport?examId=${examId}&hiddenNavigationBar=1&transition=1`;
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      //  else if (this.$root.miniprogram) {
      //   wx.miniProgram.navigateTo({
      //     url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(
      //       `https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=$7926&mpid=${
      //         isZhuanShenBen ? '689c3a67bfb7e10001e38006' : '67653f9d9d78140001e5277b'
      //       }`,
      //     )}&probeId=${isZhuanShenBen ? '689c3a67bfb7e10001e38006' : '67653f9d9d78140001e5277b'}`,
      //   });
      //   return;
      // } else {
      // window.location.href = `${window.location.origin}/mockExam/answerReport?examId=${examId}`;
      // }

      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(
            `${
              window.location.origin
            }/mockExam/answerReport?examId=${examId}&env=mini&THIRD_SESSION=${window.localStorage.getItem(
              'accessToken',
            )}`,
          )}`,
        });
      } else {
        window.location.href = `${window.location.origin}/mockExam/answerReport?examId=${examId}`;
      }
    },

    onExpandChange() {
      if (this.pageNum + 1 > this.examPages || this.nextExamLoading) {
        return;
      }
      this.pageNum += 1;

      this.nextExamLoading = true;
      const { userProductId } = this.$route.query;

      reqStudyExamInfo(userProductId, this.pageNum, 10)
        .then(res => {
          this.studyExamList = [...this.studyExamList, ...(res?.data?.examInfoVOS?.data || [])];
          this.showExam = res?.data?.examInfoVOS?.total > 0;
          this.examPages = res?.data?.examInfoVOS?.pages;
          if (this.examPages <= this.pageNum) {
            this.expandStatus = false;
          }
          this.nextExamLoading = false;
        })
        .finally(() => {
          this.nextExamLoading = false;
        });
    },
    // Y轴最大值比最大数据大20
    getMaxY() {
      // eslint-disable-next-line no-confusing-arrow
      const maxValue = this.weekTimeList.reduce((prev, cur) =>
        prev.dayLearnDuration > cur.dayLearnDuration ? prev : cur,
      );
      return maxValue.dayLearnDuration + 25;
    },

    toShare() {
      if (this.loading) return;
      this.showShare = true;
      setTimeout(() => {
        this.myChart1_modal = this.$echarts.init(document.getElementById('reportEChart1_modal'));
        if (this.studyInfo.total > 0) {
          this.myChart2_modal = this.$echarts.init(document.getElementById('reportEChart2_modal'));
        }

        const options1 = {
          series: [
            {
              type: 'gauge',
              center: ['50%', '50%'],
              startAngle: 360,
              endAngle: -45,
              min: 0,
              max: 100,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#FF9502',
                    },
                    {
                      offset: 1,
                      color: '#FF5C01',
                    },
                  ],
                },
              },
              progress: {
                show: true,
                width: 12,
                // roundCap: true,
              },
              radius: '100%',
              silent: true, // 禁用交互
              detail: {
                show: false,
              },
              axisLabel: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
              title: { show: false },
              axisLine: {
                // roundCap: true,
                lineStyle: {
                  color: [[1, '#fff2d8']], // 整个环的底色
                  width: 12,
                  shadowColor: '#fff', // 可选阴影
                  shadowBlur: -10,
                },
              },
              pointer: {
                show: false,
              },
              data: [
                {
                  name,
                  value: (this.studyInfo.productLearnProgress || 0) * 100,
                  title: {
                    offsetCenter: ['0%', '69%'],
                  },
                },
              ],
              // eslint-disable-next-line no-dupe-keys
              title: {
                fontSize: 12,
                color: '#999999',
              },
            },
          ],
        };
        const { finalNum, total } = this.studyInfo?.taskInfo || {};
        const precent = total > 0 ? Math.floor((Number(finalNum) / Number(total)) * 100) : 0;
        this.dayTaskPrecent = precent || 0;
        const options2 = {
          series: [
            {
              type: 'gauge',
              center: ['50%', '50%'],
              startAngle: 360,
              endAngle: -45,
              min: 0,
              max: 100,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#FF9502',
                    },
                    {
                      offset: 1,
                      color: '#FF5C01',
                    },
                  ],
                },
              },
              progress: {
                show: true,
                width: 12,
                // roundCap: true,
              },
              radius: '100%',
              silent: true, // 禁用交互
              detail: {
                show: false,
              },
              axisLabel: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
              title: { show: false },
              axisLine: {
                // roundCap: true,
                lineStyle: {
                  color: [[1, '#fff2d8']], // 整个环的底色
                  width: 12,
                  shadowColor: '#fff', // 可选阴影
                  shadowBlur: -10,
                },
              },
              pointer: {
                show: false,
              },
              data: [
                {
                  name,
                  value: precent || 0,
                  title: {
                    offsetCenter: ['0%', '69%'],
                  },
                },
              ],
              // eslint-disable-next-line no-dupe-keys
              title: {
                fontSize: 12,
                color: '#999999',
              },
            },
          ],
        };

        this.myChart1_modal.setOption(options1);
        if (this.studyInfo.total > 0) {
          this.myChart2_modal.setOption(options2);
        }
        setTimeout(() => {
          let timer = setInterval(() => {
            if (this.imgLoadNum >= 2) {
              this.toImage();
              clearInterval(timer);
              timer = null;
            }
          }, 100);
        }, 700);
      }, 10);
    },

    async getStudyBasisInfo() {
      const { userProductId } = this.$route.query;
      // 查询用户学习报告基础信息;
      const p1 = reqStudyBasisInfo(userProductId);
      // 查询用户学习报告服务信息
      const p2 = reqStudyServiceInfo(userProductId);
      // 查询用户学习报告考试信息
      const p3 = reqStudyExamInfo(userProductId, this.pageNum, 10);
      // 查询用户学习报告周学习时长信息
      // const p4 = reqStudyWeekTime(userProductId);
      // 查询每日任务信息
      const p4 = reqStudyDayTaskInfo(userProductId);

      reqCheckUserCourse(userProductId).then((res) => {
        console.log('产品id', res)
        const { productId, skuId} = res
        this.productId = productId
        this.skuId = skuId
      })

      Promise.all([p1, p2, p3, p4]).then(result => {
        const res = result[0];
        const res1 = result[1];
        const res2 = result[2];
        const res3 = result[3];
        // const res4 = result[4];
        this.loading = false;
        if (!res.data && !res1.data && !res2.data && !res3.data) {
          this.isEmpty = true;
          return;
        }
        this.studyInfo = {
          ...res1?.data,
          ...res2?.data,
          ...res?.data,
          taskInfo: res3?.data,
          ...res3?.data,
        };
        this.studyExamList = res2?.data?.examInfoVOS?.data || [];
        this.showExam = res2?.data?.examInfoVOS?.total > 0;
        this.examPages = res2?.data?.examInfoVOS?.pages;
        if (this.examPages <= this.pageNum) {
          this.expandStatus = false;
        }
        this.renderChat({
          ...res1?.data,
          ...res2?.data,
          ...res?.data,
          taskInfo: res3?.data,
          ...res3?.data,
        });
      });
    },

    // 饼状图
    renderChat(studyInfo) {
      const options1 = {
        series: [
          {
            type: 'gauge',
            center: ['50%', '50%'],
            startAngle: 360,
            endAngle: -45,
            min: 0,
            max: 100,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#FF9502',
                  },
                  {
                    offset: 1,
                    color: '#FF5C01',
                  },
                ],
              },
            },
            progress: {
              show: true,
              width: 12,
              // roundCap: true,
            },
            radius: '100%',
            silent: true, // 禁用交互
            detail: {
              show: false,
            },
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            title: { show: false },
            axisLine: {
              // roundCap: true,
              lineStyle: {
                color: [[1, '#fff2d8']], // 整个环的底色
                width: 12,
                shadowColor: '#fff', // 可选阴影
                shadowBlur: -10,
              },
            },
            pointer: {
              show: false,
            },
            data: [
              {
                name,
                value: (studyInfo.productLearnProgress || 0) * 100,
                title: {
                  offsetCenter: ['0%', '69%'],
                },
              },
            ],
            // eslint-disable-next-line no-dupe-keys
            title: {
              fontSize: 12,
              color: '#999999',
            },
          },
        ],
      };
      const { finalNum, total } = studyInfo?.taskInfo || {};
      const precent = total > 0 ? Math.floor((Number(finalNum) / Number(total)) * 100) : 0;
      this.dayTaskPrecent = precent || 0;
      const options2 = {
        series: [
          {
            type: 'gauge',
            center: ['50%', '50%'],
            startAngle: 360,
            endAngle: -45,
            min: 0,
            max: 100,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#FF9502',
                  },
                  {
                    offset: 1,
                    color: '#FF5C01',
                  },
                ],
              },
            },
            progress: {
              show: true,
              width: 12,
              // roundCap: true,
            },
            radius: '100%',
            silent: true, // 禁用交互
            detail: {
              show: false,
            },
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            title: { show: false },
            axisLine: {
              // roundCap: true,
              lineStyle: {
                color: [[1, '#fff2d8']], // 整个环的底色
                width: 12,
                shadowColor: '#fff', // 可选阴影
                shadowBlur: -10,
              },
            },
            pointer: {
              show: false,
            },
            data: [
              {
                name,
                value: precent || 0,
                title: {
                  offsetCenter: ['0%', '69%'],
                },
              },
            ],
            // eslint-disable-next-line no-dupe-keys
            title: {
              fontSize: 12,
              color: '#999999',
            },
          },
        ],
      };
      console.log('myChart1', this.myChart1s);

      this.myChart1.setOption(options1);
      this.myChart2.setOption(options2);
    },

    // 获取日统计数据
    getStudyDayTimeInfo() {
      const { userProductId } = this.$route.query;

      reqStudyDayTime(userProductId).then(res => {
        console.log('res', res);
        const { ratio, learnDuration, detailRespVOS } = res?.data || {};
        let showUp = false;
        let showDown = false;
        if (ratio > 0) {
          showUp = true;
        }
        if (ratio == 0) {
          if (learnDuration > 0) {
            showUp = true;
          }
        }
        if (ratio < 0) {
          showDown = true;
        }
        this.dayInfo = {
          showUp,
          showDown,
          ratio,
          learnDuration,
        };
        let allTime = 0;
        const weekTimeList =
          detailRespVOS?.map(item => {
            const { learnDay, learnDuration } = item;
            const rowDay = learnDay
              ?.slice(5)
              .split('-')
              .join('.');
            allTime += learnDuration || 0;

            return {
              statisticsDate: rowDay,
              dayLearnDuration: learnDuration || 0,
            };
          }) || [];
        if (weekTimeList.length === 0) {
          return;
        }
        this.weekTimeShow = allTime > 0;
        this.weekTimeList = weekTimeList;
        this.weekAverage = (allTime / 7).toFixed(1);
        const { statisticsDate, dayLearnDuration } = weekTimeList[weekTimeList.length - 1];
        this.lastStudyInfo = {
          statisticsDate: statisticsDate.split('.').join('月') + '日',
          dayLearnDuration,
        };

        const columnPlot = new Column('columnchart', {
          data: weekTimeList,
          // height: 220,
          tooltip: false, // 不显示柱形图的提示数据
          xField: 'statisticsDate',
          yField: 'dayLearnDuration',
          columnStyle: {
            radius: [14, 14, 14, 14],
            fill: 'l(90) 0:#FF7634 1:#FFA376', // 柱形颜色
          },
          label: {
            // 柱形图上的数字
            content: originData => {
              const val = `${originData.dayLearnDuration}min`;
              return val;
            },
            style: {
              fill: '#666',
              fontSize: 14,
              fontWeight: 400,
              opacity: 0.6,
            },
          },
          maxColumnWidth: 14,
          yAxis: {
            // 去掉背景横杠
            grid: null,
            max: this.getMaxY(),
            label: null, //去掉Y轴
          },
          xAxis: {
            // 增加竖着的虚线
            grid: {
              line: {
                style: {
                  stroke: '#E8E8E8',
                  lineWidth: 2,
                  lineDash: [4, 5],
                  strokeOpacity: 0.7,
                },
              },
            },
            tickLine: null,
            line: {
              style: {
                stroke: '#fff',
              },
            },
          },
        });

        columnPlot.render();
      });
    },

    // 获取周统计数据
    getStudyWeekTimeInfo() {
      const { userProductId } = this.$route.query;

      reqStudyWeekTime(userProductId).then(res => {
        console.log('resWeek', res);
        const { data } = res || {};
        let allTime = 0;
        const weekTimeList = data.map(item => {
          const { learnDay, learnDuration } = item;
          const rowDay = learnDay
            ?.slice(5)
            .split('-')
            .join('.');

          allTime += learnDuration || 0;

          return {
            statisticsDate: rowDay,
            dayLearnDuration: learnDuration || 0,
          };
        });
        this.weekTimeShow = allTime > 0;
        this.weekTimeList = weekTimeList;
        this.weekAverage = (allTime / 7).toFixed(1);
        const { statisticsDate, dayLearnDuration } = weekTimeList[weekTimeList.length - 1];
        this.lastStudyInfo = {
          statisticsDate: statisticsDate.split('.').join('月') + '日',
          dayLearnDuration,
        };
        console.log('???week', weekTimeList);

        const columnPlot = new Column('columnchart', {
          data: weekTimeList,
          // height: 220,
          tooltip: false, // 不显示柱形图的提示数据
          xField: 'statisticsDate',
          yField: 'dayLearnDuration',
          columnStyle: {
            radius: [14, 14, 14, 14],
            fill: 'l(90) 0:#FF7634 1:#FFA376', // 柱形颜色
          },
          label: {
            // 柱形图上的数字
            content: originData => {
              const val = `${originData.dayLearnDuration}min`;
              return val;
            },
            style: {
              fill: '#666',
              fontSize: 14,
              fontWeight: 400,
              opacity: 0.6,
            },
          },
          maxColumnWidth: 14,
          yAxis: {
            // 去掉背景横杠
            grid: null,
            max: this.getMaxY(),
            label: null, //去掉Y轴
          },
          xAxis: {
            // 增加竖着的虚线
            grid: {
              line: {
                style: {
                  stroke: '#E8E8E8',
                  lineWidth: 2,
                  lineDash: [4, 5],
                  strokeOpacity: 0.7,
                },
              },
            },
            tickLine: null,
            line: {
              style: {
                stroke: '#fff',
              },
            },
          },
        });

        columnPlot.render();
      });
    },

    // 切换日/周数据
    onChangeCountType(type) {
      const dom = document.getElementById('columnchart');
      if (dom.firstChild) {
        dom.removeChild(dom.firstChild);
      }
      if (type == 1) {
        this.activeCountType = 1;
        this.getStudyDayTimeInfo();
      }
      if (type == 2) {
        this.activeCountType = 2;
        this.getStudyWeekTimeInfo();
      }
    },

    // 轮询AI内容
    getAiContent(type = 0) {
      if (this.aiLoading) {
        return;
      }
      this.aiLoading = true;
      const { userProductId } = this.$route.query;

      reqAiContent(userProductId, type).then(res => {
        console.log('resAi', res);
        const { content, status } = res.data || {};
        this.aiStatus = status;
        if (status == 1) {
          // 生成中，轮询查
          setTimeout(() => {
            this.aiLoading = false;
            this.getAiContent(0);
          }, 1000);
        }
        if (status == 2) {
          this.aiLoading = false;
          this.execAiContent(content);
        }
        if (status == 3) {
          this.aiLoading = false;
        }
      });
    },

    // 知识点
    getKnowledge() {
      const { userProductId } = this.$route.query;

      reqKnowPre(userProductId).then(res => {
        if (res.data) {
          reqKnowContent(userProductId).then(res2 => {
            const { analysisKnowledgeVOList, status } = res2?.data || {};
            console.log('resKnow', res2);
            this.knowledgeList = analysisKnowledgeVOList || [];
            this.knowledgeStatus = status;
          });
        }
      });
    },

    // 推荐位
    getCourseAd() {
      reqMajorAd(this.hotSaleId).then(res => {
        const { code, data } = res;
        console.log('resAd', res);
        if (code === 0 && data?.length) {
          const { recommendContentVOList } = data[0];
          const node = recommendContentVOList[0];
          // 排序第一的产品
          const endPoint = this.$root.$data.isApp ? 2 : 4;
          const { productId, recommendType } = node || {};
          // this.getMajorList(recommendContentVOList);
          this.recommendMore = recommendContentVOList?.length > 1;
          if (recommendType === 0) {
            reqProducts([productId], endPoint).then(res => {
              console.log('ccc', res);
              this.prodInfo = res.data?.[0];
            });
          } else {
            reqCombinationlist(0, endPoint, [productId]).then(res => {
              console.log('ttt', res);
              this.prodInfo = res.data?.[0];
            });
          }
        }
      });
    },

    // 查看更多
    lookMoreList() {
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: `/hotSaleListReport?back=back&productId=${this.productId}&skuId=${this.skuId}`,
        query: {
          recommendId: this.hotSaleId,
          recommendName: this.productName,
          source: 'report',
        },
      });
    },

    toolFixed(num) {
      return num.toFixed(0);
    },

    execAiContent(strs) {
      let i = 0;
      const timer = setInterval(() => {
        if (strs[i]) {
          this.aiContent += strs[i];
          i++;
        } else {
          clearInterval(timer);
          timer = null;
        }
      }, 10);
    },
    // async getReport() {
    //   const { userProductId } = this.$route.query;
    //   const { code, data } = await reqStudyReport(userProductId);
    //   if (code === 0 && data) {
    //     this.isEmpty = false;
    //     const { userLearnReportRespVO, userLearnReportDetailRespVO } = data;
    //     const {
    //       learnEndTime,
    //       learnStartTime,
    //       upFromLastWeek,
    //       weekLearnDuration,
    //     } = userLearnReportDetailRespVO;
    //     this.studyInfo = { ...userLearnReportRespVO, ...userLearnReportDetailRespVO };
    //     this.showWeekInfo = !(
    //       learnEndTime === null
    //       && learnStartTime === null
    //       && upFromLastWeek === null
    //       && weekLearnDuration === null
    //     );
    //   } else {
    //     this.isEmpty = true;
    //   }
    // },
    change() {
      const docEl = document.documentElement;
      if (docEl.clientWidth > 470) {
        setTimeout(() => {
          docEl.style.fontSize = '40px';
        }, 300);
      }
    },
  },

  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
      document.title = '学习报告';
    }
    this.change();
    window.onresize = () => {
      this.change();
    };
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;

    const { productName } = this.$route.query;

    this.productName = productName;

    this.myChart1 = this.$echarts.init(document.getElementById('reportEChart1'));
    this.myChart2 = this.$echarts.init(document.getElementById('reportEChart2'));

    this.getStudyBasisInfo();
    this.getStudyDayTimeInfo();
    this.getAiContent();
    this.getKnowledge();
    this.getCourseAd();
  },
};
</script>

<style lang="scss" scoped>
.close-btn {
  position: absolute;
  top: 67px;
  right: 29px;
  z-index: 999;
  display: flex;
  color: #a8a8a8;

  i {
    font-size: 40px;
  }
}
.popup {
  background: none;
  border-radius: 36px !important;
}

.container {
  font-family: PingFangSC, PingFang SC;
  background: #f7f8fc;

  .learn_progress_box_none {
    display: none;
  }

  .report_bkg {
    height: 554px;
    width: 750px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/report_bkg.png')
      no-repeat;
    background-size: cover;
    overflow: hidden;

    .bkg_name {
      width: 406px;
      height: 87px;
      font-weight: 600;
      font-size: 29px;
      color: #ffffff;
      line-height: 43px;
      overflow: hidden;
      margin-top: 174px;
      margin-left: 36px;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .bkg_title_box {
      width: 678px;
      height: 174px;
      background: #ffffff;
      border-radius: 18px;
      margin-top: 43px;
      margin-left: 36px;
      padding: 36px;

      .title_img {
        float: left;
        height: 101px;
        width: 101px;
        margin-right: 29px;
      }

      .title_name {
        float: left;
        height: 45px;
        font-weight: 600;
        font-size: 33px;
        color: #333333;
        line-height: 45px;
        width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .title_num {
        float: left;
        height: 36px;
        font-weight: 400;
        font-size: 25px;
        color: #666666;
        line-height: 36px;
        margin-top: 9px;
        div {
          color: #ff7f41;
          display: inline-block;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
    }
  }

  .under_box {
    padding: 0 36px 0;
    margin-top: -47px;
    padding-bottom: 167px;

    // 公共标题样式
    .course_progress_box {
      height: 45px;
      display: flex;
      align-items: center;

      .progress_icon {
        height: 25px;
        width: 7px;
        background: linear-gradient(#ff5d12 0%, #ffc96b 100%);
        border-radius: 4px;
      }

      .progress_text {
        height: 45px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 33px;
        color: #333333;
        line-height: 45px;
        margin-left: 7px;
        margin-right: 22px;
      }

      .progress_btn {
        display: block;
        height: 29px;
        width: 29px;
      }
    }
  }

  .course_box {
    width: 678px;
    background: #ffffff;
    border-radius: 18px;
    padding: 36px;

    .learn_progress_box {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      gap: 100px;

      .learn_progress {
        position: relative;
        width: 190px;
        height: 241px;
        display: flex;
        flex-direction: column;

        .percent {
          position: absolute;
          top: calc(50% - 20px);
          left: 50%;
          transform: translate(-50%, -50%);
          height: 51px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          line-height: 51px;
        }
      }

      .learn_progress_box_none {
        display: none;
      }
      .progress_tip {
        width: 100%;
        height: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 25px;
        color: #333333;
        line-height: 36px;
        text-align: center;
        margin-top: 10px;
      }
    }

    .learn_time_box {
      position: relative;
      // width: 612px;
      height: 94px;
      background: #f7f8fc;
      border-radius: 14px;
      margin-top: 36px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-right: 29px;

      .time_icon1 {
        display: block;
        height: 43px;
        width: 9px;
      }

      .time_icon2 {
        display: block;
        height: 51px;
        width: 51px;
        margin-left: 20px;
      }

      .time_name {
        height: 36px;
        font-weight: 400;
        font-size: 25px;
        color: #333333;
        line-height: 36px;
        margin-left: 14px;
      }

      .time_long_num {
        // position: absolute;
        // top: 27px;
        // right: 29px;
        height: 51px;
        font-weight: 600;
        font-size: 36px;
        color: #333333;
        line-height: 51px;
        margin-left: auto;
      }

      .time_long_text {
        height: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 29px;
        color: #333333;
        line-height: 40px;
      }
    }

    .learn_time_box2 {
      margin-top: 18px;
    }

    .data_box {
      margin-top: 14px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .data_item {
        width: 299px;
        height: 123px;
        background: #f7f8fc;
        border-radius: 14px;

        .data_title {
          height: 36px;
          width: 100%;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          text-align: center;
          margin-top: 18px;
        }

        .data_num {
          height: 51px;
          width: 100%;
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          line-height: 51px;
          text-align: center;
        }
      }

      .data_item_three {
        width: 194px;
      }
    }

    .data_box_three {
      gap: 12px;
      justify-content: flex-start;
    }

    .ai_box {
      margin-top: 36px;

      .ai_title_box {
        height: 72px;
        width: 612px;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyReport/ai_title_bkg.png')
          no-repeat;
        background-size: cover;

        .ai_title_fail {
          height: 72px;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 72px;
          float: right;
          margin-right: 29px;

          .ai_title_fail_btn {
            color: #6191f2;
            display: inline-block;
          }
        }

        .ai_title_loading {
          float: right;
          margin-right: 29px;
          height: 72px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 72px;
          display: flex;
          justify-content: center;
          gap: 4px;
          align-items: center;

          .ai_title_loading_icon {
            display: block;
            height: 28px;
            width: 28px;
            margin-left: 4px;
          }
        }
      }

      .ai_content_box {
        width: 612px;
        // min-height: 279px;
        background: #f7f8fc;
        border-radius: 0px 0px 14px 14px;
        padding: 16px 29px 27px;
        font-weight: 400;
        font-size: 29px;
        color: #333333;
        line-height: 47px;
      }

      .ai_content_box_fail {
        width: 612px;
        height: 279px;
        background: #f7f8fc;
        border-radius: 0px 0px 14px 14px;
        overflow: hidden;

        .ai_content_fail_img {
          display: block;
          height: 134px;
          width: 214px;
          margin: 49px auto 0;
        }

        .ai_content_fail_text {
          height: 36px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          margin-top: 11px;
          text-align: center;
        }
      }

      .ai_tip {
        height: 36px;
        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 25px;
        color: #999999;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
      }
    }
  }

  .learn_box {
    width: 678px;
    background: #ffffff;
    border-radius: 18px;
    margin-top: 29px;
    padding: 36px;

    .learn_info_box {
      margin-top: 14px;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;

      .learn_info_box_num {
        color: #ff7f41;
        display: inline;
      }

      .learn_info_box_text {
        display: inline;
      }

      .learn_info_box_img {
        height: 29px;
        width: 29px;
        transform: translateY(4px);
      }
    }

    .learn_btn_box {
      margin-top: 40px;
      height: 51px;
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 18px;

      .learn_btn {
        width: 130px;
        height: 51px;
        border-radius: 25px;
        border: 2px solid #f1f1f1;
        background: #f7f8fc;

        font-weight: 400;
        font-size: 25px;
        color: #333333;
        line-height: 51px;
        text-align: center;
      }

      .learn_btn_active {
        color: #ffffff;
        background: #ff7f41;
      }
    }

    .learn_charts_box {
      position: relative;
      width: 612px;
      background: #f7f8fc;
      border-radius: 14px;
      padding: 0px 14px 36px;
      margin-top: 29px;

      .learn_enpty {
        z-index: 10;
        position: absolute;
        height: 269px;
        width: 570px;
        top: 170px;
        left: 21px;
        background: #f7f8fc;

        .learn_enpty_img {
          height: 134px;
          width: 156px;
          display: block;
          margin: 0 auto;
        }

        .learn_enpty_text {
          height: 36px;
          width: 100%;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          margin-top: 11px;
          text-align: center;
        }
      }

      .learn_charts_title {
        height: 127px;

        .charts_mins {
          float: left;
          height: 127px;
          font-weight: 600;
          font-size: 91px;
          color: #ff7f41;
          line-height: 127px;
          margin-left: 14px;
        }

        .charts_info_box {
          float: left;
          margin-top: 27px;
          margin-left: 7px;

          .charts_info_tip {
            height: 36px;
            font-weight: 400;
            font-size: 25px;
            color: #333333;
            line-height: 36px;
          }

          .charts_info_time {
            height: 36px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #333333;
            line-height: 36px;
          }
        }
      }

      .learn_charts_line {
        width: 554px;
        height: 2px;
        border: 2px dashed #e8e8e8;
        margin: 0 auto;
      }

      .learn_charts_colmnus {
        height: 317px;
        width: 589px;
        margin-top: 20px;
      }

      .learn_charts_average {
        margin-top: 29px;
        height: 51px;
        overflow: hidden;
        display: flex;
        justify-content: center;

        .charts_average_num {
          height: 51px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          line-height: 51px;
        }

        .charts_average_tip {
          height: 36px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          margin-top: 10px;
        }
      }
    }
  }

  .test_box {
    width: 678px;
    background: #ffffff;
    border-radius: 14px;
    margin-top: 29px;
    padding: 36px;

    .test_title_box {
      display: flex;
      height: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;
      margin-top: 14px;

      .test_title_num {
        color: #ff7f41;
      }
    }

    .test_list_title {
      height: 36px;
      margin-top: 40px;
      font-weight: 400;
      font-size: 25px;
      color: #666666;

      div {
        float: left;
        height: 36px;
        line-height: 36px;
      }

      .title_name {
        margin-left: 14px;
      }

      .title_num {
        margin-left: 290px;
      }

      .title_sort {
        margin-left: 29px;
      }
    }

    .test_list_box {
      overflow: hidden;

      .test_list_item {
        widows: 100%;
        height: 87px;
        background: #f7f8fc;
        border-radius: 14px;
        margin-top: 14px;
        display: flex;
        align-items: center;

        div {
          height: 36px;
          font-weight: 500;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
        }

        .test_item_name {
          width: 341px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-left: 22px;
        }

        .test_item_num {
          width: 50px;
          font-weight: 400;
          margin-left: 43px;
          text-align: center;
        }

        .test_item_sort {
          width: 50px;
          font-weight: 400;
          margin-left: 25px;
          text-align: center;
        }

        .test_btn_icon {
          display: block;
          height: 40px;
          width: 40px;
          margin-left: 23px;
        }
      }
    }

    .test_expand {
      height: 31px;
      width: 100%;
      font-weight: 400;
      font-size: 22px;
      color: #a5a5a5;
      line-height: 31px;
      margin-top: 36px;
      display: flex;
      justify-content: center;
      gap: 4px;

      img {
        display: block;
        height: 29px;
        width: 29px;
        margin-top: 2px;
      }

      .test_expand_icon_rotate {
        transform: rotate(180deg);
      }
    }
  }

  .knowledge_box {
    width: 678px;
    background: #ffffff;
    border-radius: 14px;
    margin-top: 29px;
    padding: 36px;

    .knowledge_list_empty_img {
      display: block;
      height: 243px;
      width: 301px;
      margin: 168px auto 0;
    }
    .knowledge_list_empty_text {
      height: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;
      margin-top: 22px;
      width: 100%;
      text-align: center;
    }

    .knowledge_list_empty_block {
      height: 116px;
      width: 100%;
    }

    .knowledge_title_box {
      height: 36px;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;
      margin-top: 14px;
    }

    .knowledge_list_title {
      width: 612px;
      height: 87px;
      background: #f7f8fc;
      border-radius: 14px 14px 0px 0px;
      border: 2px solid #f1f1f1;
      margin-top: 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 22px;

      div {
        height: 36px;
        font-weight: 500;
        font-size: 25px;
        color: #333333;
        line-height: 36px;
      }
    }

    .knowledge_list_box {
      .knowledge_item {
        width: 612px;
        min-height: 87px;
        background: #ffffff;
        border: 2px solid #f1f1f1;
        border-top: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 25px 47px 22px 25px;

        .knowledge_item_name {
          width: 442px;
          font-weight: 500;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
        }

        .knowledge_item_precent {
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
        }
      }
    }

    .knowledge_course_icon {
      height: 58px;
      width: 100%;
      margin-top: 36px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .knowledge_one_img {
        height: 58px;
        width: 500px;
        margin-right: auto;
      }

      .knowledge_one_tip {
        height: 31px;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        line-height: 31px;
        margin-right: 7px;
      }

      .knowledge_one_more {
        display: block;
        height: 16px;
        width: 9px;
      }
    }

    .knowledge_course_box {
      width: 612px;
      height: 181px;
      background: #fff9e9;
      border-radius: 14px;
      border: 2px solid #f1d8b8;
      margin-top: 22px;
      position: relative;

      .knowledge_course_img {
        float: left;
        width: 188px;
        height: 136px;
        margin-top: 24px;
        margin-left: 22px;
      }

      .knowledge_course_name {
        float: left;
        width: 366px;
        height: 33px;
        font-weight: 500;
        font-size: 25px;
        color: #333333;
        line-height: 33px;
        margin-top: 25px;
        margin-left: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .knowledge_course_num {
        float: left;
        height: 25px;
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        line-height: 25px;
        margin-top: 7px;
        margin-left: 14px;
      }

      .knowledge_course_price {
        float: left;
        margin-top: 18px;
        margin-left: 14px;
        width: 300px;
        display: flex;

        .course_line_price {
          height: 31px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #999999;
          line-height: 31px;
        }

        .course_price_box {
          display: flex;
          align-items: center;
          justify-content: center;

          .course_price_tip {
            width: 65px;
            height: 29px;
            background: #ff3938;
            border-radius: 5px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            line-height: 29px;
            text-align: center;
          }

          .course_price_icon {
            height: 51px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #ff3938;
            line-height: 56px;
          }

          .course_price_num {
            height: 51px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 36px;
            color: #ff3938;
            line-height: 45px;
          }

          .course_price_free {
            height: 51px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 36px;
            color: #ff3938;
            line-height: 45px;
          }
        }

        .knowledge_price_active {
          width: 65px;
          height: 29px;
          background: #ff3938;
          border-radius: 5px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 29px;
          text-align: center;
          margin-top: 14px;
        }

        .knowledge_price_value {
          height: 51px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 25px;
          color: #ff3938;
          line-height: 51px;
        }
      }

      .knowledge_course_btn {
        position: absolute;
        width: 125px;
        height: 42px;
        background: #ff7f41;
        border-radius: 21px;
        bottom: 22px;
        right: 22px;

        font-weight: 500;
        font-size: 22px;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
      }
    }
  }

  .share_box {
    width: 714px;
    height: 1275px;
    background: #fdbd92;
    border-radius: 36px;
    overflow: hidden;

    .share_bkg {
      position: absolute;
      width: 714px;
      height: 326px;
      top: 0;
      left: 0;
      z-index: 0;
    }

    .share_title {
      position: relative;
      z-index: 1;
      width: 475px;
      height: 72px;
      font-weight: 500;
      font-size: 25px;
      color: #ffffff;
      line-height: 36px;
      margin-top: 71px;
      margin-left: 29px;
    }

    .share_days {
      position: relative;
      z-index: 1;
      width: 362px;
      height: 43px;
      background: #ffffff;
      border-radius: 11px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #333333;
      line-height: 43px;

      margin-top: 11px;
      margin-left: 18px;
      padding-left: 14px;

      div {
        color: #ff7f41;
        display: inline-block;
        padding-left: 3px;
        padding-right: 3px;
      }
    }

    .course_box {
      position: relative;
      z-index: 1;
      width: 678px;
      background: #ffffff;
      border-radius: 18px 18px 0px 0px;
      padding: 36px;
      height: 882px;
      margin-top: 14px;
      margin-left: 18px;

      .learn_progress_box {
        margin-top: 36px;
        display: flex;
        justify-content: center;
        gap: 100px;

        .learn_progress {
          position: relative;
          width: 190px;
          height: 241px;
          display: flex;
          flex-direction: column;

          .percent {
            position: absolute;
            top: calc(50% - 20px);
            left: 50%;
            transform: translate(-50%, -50%);
            height: 51px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 36px;
            color: #333333;
            line-height: 51px;
          }
        }

        .progress_tip {
          width: 100%;
          height: 36px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          text-align: center;
          margin-top: 10px;
        }
      }

      .learn_time_box {
        position: relative;
        width: 612px;
        height: 94px;
        background: #f7f8fc;
        border-radius: 14px;
        margin-top: 36px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-right: 29px;

        .time_icon1 {
          height: 43px;
          width: 9px;
        }

        .time_icon2 {
          height: 51px;
          width: 51px;
          margin-left: 20px;
        }

        .time_name {
          height: 36px;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          margin-left: 14px;
        }

        .time_long_num {
          // position: absolute;
          // top: 27px;
          // right: 29px;
          height: 51px;
          font-weight: 600;
          font-size: 36px;
          color: #333333;
          line-height: 51px;
          margin-left: auto;
        }

        .time_long_text {
          height: 40px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 29px;
          color: #333333;
          line-height: 40px;
        }
      }

      .learn_time_box2 {
        margin-top: 18px;
      }

      .data_box {
        margin-top: 14px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .data_item {
          width: 299px;
          height: 123px;
          background: #f7f8fc;
          border-radius: 14px;

          .data_title {
            height: 36px;
            width: 100%;
            font-weight: 400;
            font-size: 25px;
            color: #333333;
            line-height: 36px;
            text-align: center;
            margin-top: 18px;
          }

          .data_num {
            height: 51px;
            width: 100%;
            font-weight: 600;
            font-size: 36px;
            color: #333333;
            line-height: 51px;
            text-align: center;
          }
        }

        .data_item_three {
          width: 194px;
        }
      }

      .data_box_three {
        gap: 12px;
        justify-content: flex-start;
      }
    }

    .share_code_box {
      width: 678px;
      height: 163px;
      background: #f1f6ff;
      border-radius: 0px 0px 18px 18px;
      margin-left: 18px;
      overflow: hidden;

      .share_qh_img {
        float: left;
        display: block;
        height: 60px;
        width: 198px;
        margin-top: 53px;
        margin-left: 45px;
      }

      .share_load_code {
        float: left;
        display: block;
        height: 127px;
        width: 127px;
        border: 1px solid #dcdcdc;
        margin-top: 18px;
        margin-left: 264px;
      }
    }

    .course_progress_box {
      height: 45px;
      display: flex;
      align-items: center;

      .progress_icon {
        height: 25px;
        width: 7px;
        background: linear-gradient(#ff5d12 0%, #ffc96b 100%);
        border-radius: 4px;
      }

      .progress_text {
        height: 45px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 33px;
        color: #333333;
        line-height: 45px;
        margin-left: 7px;
        margin-right: 22px;
      }

      .progress_btn {
        display: block;
        height: 29px;
        width: 29px;
      }
    }
  }

  .share_img_box {
    display: block;
    width: 714px;
    height: 1275px;
    border-radius: 36px;
  }
}

.section {
  padding: 100px 0 30px 0;
}

.miniprogram {
  padding-top: 0;
}

.head-top {
  width: 750px;
  height: 438px;
  margin: 0 auto;
  padding: 58px 36px 0 36px;
  background-color: #ff6b00;
  background-image: url('../../../assets/img/learningGuidePage/report-head.png');
  background-repeat: no-repeat;
  background-size: 100%;

  .head-img {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > img {
      width: 109px;
      height: 109px;
      margin-right: 22px;
      border: 5px solid #fff;
      border-radius: 50%;
    }

    > div {
      span {
        display: inline-block;
        width: 350px;
        overflow: hidden;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      p {
        color: #fff;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }

  .head-time {
    padding: 36px 0 33px 0;
    color: #fff;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
  }
}

.study-progress {
  position: relative;
  top: -150px;
  z-index: 1;
}

.study-week {
  position: relative;
  top: -130px;
  z-index: 1;
}

.columnBox {
  position: relative;
  top: -130px;
}

.examList {
  position: relative;
  top: -110px;
}

.share-btn-Box {
  position: fixed;
  z-index: 11;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 167px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px -4px 18px 0px rgba(0, 0, 0, 0.07);

  .share-btn {
    // z-index: 20;
    width: 678px;
    // position: fixed;
    // bottom: 20px;
    // left: 36px;
    // right: 36px;
    margin: 22px auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }
}

.emptyIndent {
  padding-top: 200px;
}
</style>
